import axios from "@/plugins/axios";
import { ActionTree } from "vuex";
import { User } from "../../shared/User";
import { RootState } from "../types";
import setAxiosHeaders from "./helpers";
import {
  orderSites,
  orderSitesWithPos,
  orderSitesWithVendeurs,
} from "./helpers";
import { LoginState } from "./types";
import { AxiosError, AxiosResponse } from "axios";

export const actions: ActionTree<LoginState, RootState> = {
  async login({ state, commit }, user: User) {
    if (!user) {
      commit("LOGOUT");
      return;
    }
    let token: string;
    const mylogin = user.login;
    token = window.btoa(
      unescape(encodeURIComponent(user.login + ":" + user.password))
    );
    localStorage.setItem("token", token);
    setAxiosHeaders(token);
    const toReturn = await axios
      .get("bo/connexion?username=" + user.login, {
        auth: {
          username: mylogin,
          password: user.password,
        },
      })
      .then((response) => {
        // console.log(response);
        const myuser = new User();
        myuser.init(
          mylogin,
          response.data.id,
          response.data.droits,
          response.data.currency,
          token,
          response.data.role ? response.data.role : ""
        );
        commit("LOGIN", myuser);
        return myuser;
      })
      .catch((error) => {
        console.log(error);
        if (error) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.data);
          console.log(error.status);
          console.log(error.headers);
        }
        return Promise.reject(error);
      });
  },
  async directLogin({ commit }, user: User) {
    if (!user) {
      commit("LOGOUT");
      return;
    }
    // console.log(user, user.token);
    const mylogin = user.login;
    const token = user.token;
    setAxiosHeaders(user.token);
    const toReturn = await axios
      .get("bo/connexion?username=" + mylogin)
      .then((response) => {
        // console.log(response);
        const myuser = new User();
        myuser.init(
          mylogin,
          response.data.id,
          response.data.droits,
          response.data.currency,
          token,
          response.data.role ? response.data.role : ""
        );
        commit("LOGIN", myuser);
        return myuser;
      })
      .catch((error) => {
        return Promise.reject(error.data);
      });
  },
  logout({ commit }) {
    commit("LOGOUT");
    commit("CLEAR");
    return true;
  },
  setLoading({ commit }, loading) {
    // console.log("updating loading state ", loading);
    commit("LOADING", loading);
  },
  async getSites({ dispatch, commit, state }, client) {
    try {
      commit("LOADING", true);
      const user = state.user;
      if (user === null || user === undefined) {
        commit("LOGOUT");
        throw new Error("NoConnectedUser");
      }

      // Attends la réponse de l'API
      const response = await axios.get("bo/getSites?id=" + user.id);

      // Une fois les données récupérées, traite-les
      const mesSites: any = response.data;

      // Désactive le chargement et appelle d'autres dispatchs
      commit("LOADING", false);
      dispatch("getGroupements", { user, sites: mesSites, client });
    } catch (error) {
      const axiosError = error as AxiosError;
      return Promise.reject(
        axiosError.response ? axiosError.response.data : undefined
      );
    }
  },
  async getEnseignes({ dispatch, commit, state }, client) {
    try {
      commit("LOADING", true);
      const user = state.user;
      if (user === null || user === undefined) {
        commit("LOGOUT");
        throw new Error("NoConnectedUser");
      }
      const resp = await axios
        .get("bo/getEnseignes?id=" + user.id)
        .then((response) => {
          commit("SET_ENSEIGNES", response.data);
        });
    } catch (error) {
      const axiosError = error as AxiosError;
      return Promise.reject(
        axiosError.response ? axiosError.response.data : undefined
      );
    }
  },
  async getSirets({ dispatch, commit, state }, client) {
    try {
      commit("LOADING", true);
      const user = state.user;
      if (user === null || user === undefined) {
        commit("LOGOUT");
        throw new Error("NoConnectedUser");
      }
      const resp = await axios
        .get("bo/getSirets?id=" + user.id)
        .then((response) => {
          commit("SET_SIRETS", response.data);
        });
    } catch (error) {
      const axiosError = error as AxiosError;
      return Promise.reject(
        axiosError.response ? axiosError.response.data : undefined
      );
    }
  },
  async getGroupements({ dispatch, commit, state }, payload) {
    try {
      const response = await axios.get(
        "bo/infra/getRegroupements?id=" + payload.user.id
      );
      const groupements = response.data;
      const mesSitesOr = orderSites(payload.sites, groupements, payload.client);
      dispatch("getVendeurs", {
        user: payload.user,
        sites: mesSitesOr,
        client: payload.client,
      });
      commit("SET_GROUPEMENTS", groupements);
      commit("SET_SITES", mesSitesOr);
      localStorage.siteToken = Date.now();
      return mesSitesOr;
    } catch (error) {
      // console.log(error)
      if (
        typeof error === "object" &&
        error !== null &&
        "response" in error &&
        (error.response as AxiosResponse).status === 401
      ) {
        commit("LOGOUT");
      }
      return null;
    }
  },
  async getCaisses({ commit, state }, payload) {
    try {
      const response = await axios.get("bo/getCaisses?id=" + payload.user.id);
      const caisses = response.data;
      const mesSitesOr = orderSitesWithPos(payload.sites, caisses);
      // console.log(mesSitesOr);
      commit("SET_SITES", mesSitesOr);
      return mesSitesOr;
    } catch (error) {
      // console.log(error)
      if (
        typeof error === "object" &&
        error !== null &&
        "response" in error &&
        (error.response as AxiosResponse).status === 401
      ) {
        commit("LOGOUT");
      }
      return null;
    }
  },
  async getVendeurs({ commit, dispatch }, payload) {
    if (payload.client === "TOTAL") {
      return;
    }
    console.log("getVendeurs");
    try {
      const response = await axios.get("bo/getVendeurs?id=" + payload.user.id);
      const vendeurs = response.data;
      console.log("vendeurs ", response.data);
      const mesSitesOr = orderSitesWithVendeurs(payload.sites, vendeurs);
      dispatch("getCaisses", { user: payload.user, sites: mesSitesOr });
      commit("SET_SITES", mesSitesOr);
      return mesSitesOr;
    } catch (error) {
      // console.log(error)
      if (
        typeof error === "object" &&
        error !== null &&
        "response" in error &&
        (error.response as AxiosResponse).status === 401
      ) {
        commit("LOGOUT");
      }
      return null;
    }
  },
  async getUtilisateur({ commit, state }, user) {
    // console.log("get utilisateur")
    try {
      const response = await axios.get(
        "bo/infra/getUtilisateur?login=" + user.login
      );
      const moi = response.data;
      // console.log("moi", user)
      return moi;
    } catch (error) {
      console.log(error);
      return null;
    }
  },
  async updateMe({ commit }, userToUpdate) {
    const url = `bo/infra/saveUtilisateur?id=${userToUpdate.id}`;
    const ids = userToUpdate.societesPlus.map((societe: any) => societe.id);
    const idsMoins = userToUpdate.societesMoins.map(
      (societe: any) => societe.id
    );
    let URLConfig = `login=${userToUpdate.login}&email=${
      userToUpdate.email
    }&profileId=${userToUpdate.profile.id}&activationKey=${
      userToUpdate.activationKey
    }&theme=${userToUpdate.theme}&couleur=${
      userToUpdate.couleur
    }&societesIdPlus=${ids.toString()}&societesIdMoins=${idsMoins.toString()}`;
    if (userToUpdate.password !== null && userToUpdate.password !== undefined) {
      URLConfig =
        URLConfig +
        `&updatePassword=true&password=${userToUpdate.newPassword}&rePasswordKey=${userToUpdate.rePasswordKey}`;
    } else {
      URLConfig =
        URLConfig +
        `&updatePassword=false&password=${userToUpdate.password}&rePasswordKey=${userToUpdate.password}`;
    }
    // console.log(URLConfig) ;
    return await axios
      .post(url, URLConfig, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then(
        (response: any) => {
          // console.log(response);
          const token = window.btoa(
            userToUpdate.login + ":" + userToUpdate.newPassword
          );
          localStorage.setItem("token", token);
          setAxiosHeaders(token);
          return response;
        },
        (status: any) => {
          // console.log(status);
          return status;
        }
      );
  },
  async reinitPass({ commit }, login) {
    const url = `reinit/sendReinitMail?user=${login}`;
    return await axios
      .get(url)
      .then(
        (response: any) => {
          // console.log(response)
          return response;
        }
      )
      .catch((error: any) => {
        const status = error.response ? error.response.status : null;
        return Promise.reject({
          status
        });
      });
  },
  async reinitPassTotal({ commit }, payload: { login: string; locale?: string }) {
    let url = `reinit/sendReinitMail?user=${payload.login}`;
    if (payload.locale) {
        url += `&locale=${payload.locale}`;
    }
    return await axios
        .get(url, {
            headers: {
                Authorization: ""
            }
        })
        .then((response: any) => {
            return response;
        })
        .catch((error: any) => {
            const status = error.response ? error.response.status : null;
            return Promise.reject({
                status
            });
        });
  },
  async reinitPassConfirmation({ commit }, payload) {
    return await axios
      .get("reinit/reinitPassword", {
        params: {
          email: payload.email,
          resetPasswordKey: payload.resetPasswordKey,
          password: payload.password
        }
      })
      .then(
        (response: any) => {
          return response;
        }
      )
      .catch((error: any) => {
        const status = error.response ? error.response.status : null;
        return Promise.reject({
          status
        });
      });
  },
  async setLanguage({ commit }, language) {
    commit("SET_LANGUAGE", language);
  },
};
